export default __webpack_public_path__ + "static/media/smol-span.717ea599.png";